import { IApiGPlayer } from "pkm-special-tool"
import { Router } from "../../utils/Router"
import { Home } from "../Home"
import { TOURNAMENT_API_URL } from "./TournamentsCRUD"

export class UserTournaments extends Home{
    public apiURL = TOURNAMENT_API_URL + "/user-tournaments"
    protected BACK_URL = Router.MY_TOURNAMENTS_URL

    public isAuthorized = (user?: IApiGPlayer) => !!user && user.isGoogle
}